module.exports = __webpack_public_path__ + "img/en.ae7a990.svg";